module.exports = __webpack_public_path__ + "img/_namibia.4874fee9.png";